module.exports = __webpack_public_path__ + "static/img/github.8dcc6b52.svg";